<template>

    <div>
        <!-- ***** start custom content ***** -->
        <h1>{{$t('voter_list')}}</h1>

        <h2 class="mb-4">{{$t('step_5_thank_you')}}</h2>
        <p>{{$t('step_5_note_1')}}</p>
        <p>{{$t('step_5_note_2')}}</p>

        <ul class="list-unstyled">
            <li><a @click="go_to_step('Home')">{{ $t('check_another') }}</a></li>
            <!--
            <li><a href="/clerks/election/byelection2021/registration/WhereDoIVote.stm#where-do-i-vote">Where do I vote?</a></li>
            -->
        </ul>

        <!-- ***** end custom content ***** -->
    </div>
</template>
<script>

    export default {
        data() {
            return {
            }
        },
        methods: {
            go_to_step: function (step) {
                this.$router.push({ name: step });
            }
        }
    }
</script>
